const Index = () => import("@/views/Index");
const routes = [
    {
        path: "/",
        redirect: {
            name: "index",
        },
    },
    {
        path: "/index",
        component: () => import("@/layouts"),
        children: [{ path: "/", name: "index", component: Index }],
    },
];
export default routes;
